export default __webpack_public_path__ + "static/post5-f38263accae6a2dd0d4250b5a617707e.jpg";